export default __webpack_public_path__ + "static/media/Note_1_img.b1632eec.jpg";